module.exports = __webpack_public_path__ + "static/media/vault_cropped.c599b67f.png";